var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDeclinedInviteIcon = function SvgDeclinedInviteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "declined-invite-icon_svg__a",
    width: 18,
    height: 18,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#373737",
    mask: "url(#declined-invite-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.25,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m6 6 6 6m0-6-6 6"
  }))));
};
export default SvgDeclinedInviteIcon;